import {camelCase} from 'lodash';

const industriesString = `Accounting,
Airlines/Aviation,
Alternative Dispute Resolution,
Alternative Medicine,
Animation,
Apparel/Fashion,
Architecture/Planning,
Arts/Crafts,
Automotive,
Aviation/Aerospace,
Banking/Mortgage,
Biotechnology/Greentech,
Broadcast Media,
Building Materials,
Business Supplies/Equipment,
Capital Markets/Hedge Fund/Private Equity,
Chemicals,
Civic/Social Organization,
Civil Engineering,
Commercial Real Estate,
Computer Games,
Computer Hardware,
Computer Networking,
Computer Software/Engineering,
Computer/Network Security,
Construction,
Consumer Electronics,
Consumer Goods,
Consumer Services,
Cosmetics,
Dairy,
Defense/Space,
Design,
E-Learning,
Education Management,
Electrical/Electronic Manufacturing,
Entertainment/Movie Production,
Environmental Services,
Events Services,
Executive Office,
Facilities Services,
Farming,
Financial Services,
Fine Art,
Fishery,
Food Production,
Food/Beverages,
Fundraising,
Furniture,
Gambling/Casinos,
Glass/Ceramics/Concrete,
Government Administration,
Government Relations,
Graphic Design/Web Design,
Health/Fitness,
Higher Education/Acadamia,
Hospital/Health Care,
Hospitality,
Human Resources/HR,
Import/Export,
Individual/Family Services,
Industrial Automation,
Information Services,
Information Technology/IT,
Insurance,
International Affairs,
International Trade/Development,
Internet,
Investment Banking/Venture,
Investment Management/Hedge Fund/Private Equity,
Judiciary,
Law Enforcement,
Law Practice/Law Firms,
Legal Services,
Legislative Office,
Leisure/Travel,
Library,
Logistics/Procurement,
Luxury Goods/Jewelry,
Machinery,
Management Consulting,
Maritime,
Market Research,
Marketing/Advertising/Sales,
Mechanical or Industrial Engineering,
Media Production,
Medical Equipment,
Medical Practice,
Mental Health Care,
Military Industry,
Mining/Metals,
Motion Pictures/Film,
Museums/Institutions,
Music,
Nanotechnology,
Newspapers/Journalism,
Non-Profit/Volunteering,
Oil/Energy/Solar/Greentech,
Online Publishing,
Other Industry,
Outsourcing/Offshoring,
Package/Freight Delivery,
Packaging/Containers,
Paper/Forest Products,
Performing Arts,
Pharmaceuticals,
Philanthropy,
Photography,
Plastics,
Political Organization,
Primary/Secondary Education,
Printing,
Professional Training,
Program Development,
Public Relations/PR,
Public Safety,
Publishing Industry,
Railroad Manufacture,
Ranching,
Real Estate/Mortgage,
Recreational Facilities/Services,
Religious Institutions,
Renewables/Environment,
Research Industry,
Restaurants,
Retail Industry,
Security/Investigations,
Semiconductors,
Shipbuilding,
Sporting Goods,
Sports,
Staffing/Recruiting,
Supermarkets,
Telecommunications,
Textiles,
Think Tanks,
Tobacco,
Translation/Localization,
Transportation,
Utilities,
Venture Capital/VC,
Veterinary,
Warehousing,
Wholesale,
Wine/Spirits,
Wireless,
Writing/Editing`;
export const Industry = industriesString.split(',').map(str => str.replace(/\n/, ''));

export const TranslateIndustries = t => Industry.map(i => t(`industries.${camelCase(i)}`));

export const CompanyResponsibilities = {
    operationsAndManagement: 'Operations and management',
    businessDevelopment: 'Business development',
    softwareDevelopment: 'Software development',
    responsibility1: 'Responsibility 1',
    responsibility2: 'Responsibility 2',
    other: 'Other',
};

export const CompanySizes = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i'];
export const TranslateCompanySizes = t => CompanySizes.map(size => t(`companySizes.${size}`));

export const Revenues = [
    '10t',
    '25t',
    '50t',
    '100t',
    '250t',
    '500t',
    '1m',
    '10m',
    '50m',
    '100m',
    '250m',
    '500m',
    '1b',
    '10b',
    '10b+',
];
export const TranslateRevenues = t => Revenues.map(revenue => t(`revenue.${revenue}`));

export const CompanyPosition = [
    'Board of Directors',
    'C-Level or C-Suite',
    'Shareholder',
    'Manager',
    'Supervisor',
    'Front-Line Employee',
    'Quality Control',
    'Human Resources',
    'Accounting Staff',
    ' Marketing Staff',
    'Purchasing Staff',
    'Shipping and Receiving Staff',
    'Office Manager',
    'Receptionist',
    'Other',
];

export const TranslateCompanyPositions = t =>
    CompanyPosition.map(position => t(`companyPositions.${camelCase(position)}`));

export const CompanyDivision = [
    'Accountancy, banking and finance',
    'Business, consulting and management',
    'Charity and voluntary work',
    'Creative arts and design',
    'Energy and utilities',
    'Engineering and manufacturing',
    'Environment and agriculture',
    'Healthcare',
    'Hospitality and events management',
    'Information technology',
    'Law',
    'Law enforcement and security',
    'Leisure, sport and tourism',
    'Marketing, advertising and PR',
    'Media and internet',
    'Property and construction',
    'Public services and administration',
    'Recruitment and HR',
    'Retail',
    'Sales',
    'Science and pharmaceuticals',
    'Social care',
    'Teacher training and education',
    'Transport and logistics',
    'Other',
];

export const TranslateCompanyDivisions = t => CompanyDivision.map(d => t(`companyDivisions.${camelCase(d)}`));
